import { useCallback, useMemo } from 'react';
import { arraysEqual } from '../helpers/helper';

const useTravelClass = ({ dispatch, value, initValue }) => {
  const onChange = useCallback(
    (selectedClass) => {
      dispatch({ type: 'TRAVEL_CLASS_CHANGE', payload: [selectedClass.value] });
    },
    [dispatch]
  );

  return useMemo(
    () => ({
      value,
      defaultValue: value ? value[0] : undefined,
      onChange,
      isChanged: Array.isArray(initValue) ? !arraysEqual(initValue, value) : initValue !== value
    }),
    [value, onChange, initValue]
  );
};

export default useTravelClass;
